<div class="border-card border-0 px-4 py-1 scroll-container" ref="manage_workflow">
  <NavigationBackButton  />
  <div class="card card-nav-tabs mt-5 rounded-lg border-0 shadow p-1">
    <div class="card-header card-header-primary shadow-2 rounded-lg">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li class="nav-item">
              <a class="text-dark text-decoration-none text-x nav-link" data-toggle="tab">
                {{workflow_name}}
              </a>
            </li>
            </ul>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center p-3">
      <span v-if="workflow_statuses.length === 0" class="text-muted text-x">
        No statuses assigned
      </span>
      <span v-else class="text-x">
        Statuses Assigned
      </span>
      <button
        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
        data-bs-toggle="modal"
        data-bs-target="#assign_status_to_workflow"
      >
        Assign Status
      </button>
    </div>

    <div class="card-body">
      <div v-for="(status, index) in workflow_statuses" :key="index" class="mb-3 border rounded shadow-sm">
        <!-- Header section with the order badge inside -->
        <div class="d-flex justify-content-between align-items-center p-2 position-relative">
          <div class="order-badge">{{ status.order_number }}</div>
          <div class="text-xxs ps-4">{{ status.status }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Assign Status Modal -->
<teleport to="body">
<div class="modal fade" id="assign_status_to_workflow" tabindex="-1" aria-labelledby="assign_status_to_workflow_label" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content bg-white rounded-3">
      <div class="modal-header border-bottom-0 custom-header text-white">
        <h5 class="modal-title text-xxs" id="assign_status_to_workflow_label">Assign Status</h5>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body py-5">
        <table id="assign_form_status_table" class="table-responsive w-100 table table-hover">
          <thead class="custom-header">
            <tr>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">ID</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Status Name</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Order</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Assign</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(status, index) in statuses" :key="status.ID">
              <td class="text-xxs text-start">{{ status.ID }}</td>
              <td class="text-xxs text-start">{{ status.status_name }}</td>
              <td class="text-xxs text-start">
                <select
                  class="form-select form-select-sm w-auto text-xxs" v-model="status.order">
                  <option value="" disabled>select number</option>
                  <option v-for="n in get_available_order_numbers(status)" :key="n" :value="n">{{ n }}</option>
                </select>
              </td>
              <td class="text-xxs text-start w-25">
                <div class="form-check form-switch d-flex">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="status.is_assigned"
                    :checked="status.is_assigned"
                    @change="handle_assignment_toggle(status)">
                </div>
                <div class="min-vh-1 text-wrap">
                  <small v-if="status.show_validation" class="text-danger text-xxs">Please select an order number before assigning status.</small>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</teleport>